// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/cssWithMappingToString.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "._9pZmS74dWumn1Giz03gZRg\\=\\= {\n  display: flex;\n  flex-wrap: wrap;\n}\n.KYT0jaufJEKUU2LGEN4IzQ\\=\\= {\n  margin: 0;\n  font-size: 0.7em;\n}\n", "",{"version":3,"sources":["webpack://./src/shared/styles/MultiSelect.module.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,eAAe;AACjB;AACA;EACE,SAAS;EACT,gBAAgB;AAClB","sourcesContent":[".chips {\n  display: flex;\n  flex-wrap: wrap;\n}\n.chip {\n  margin: 0;\n  font-size: 0.7em;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"chips": "_9pZmS74dWumn1Giz03gZRg==",
	"chip": "KYT0jaufJEKUU2LGEN4IzQ=="
};
export default ___CSS_LOADER_EXPORT___;
